export const names = {
  first: [
    "Aaron",
    "Amy",
    "Andrew",
    "Anne",
    "Anthony",
    "Becca",
    "Bella",
    "Betty",
    "Bill",
    "Billy",
    "Blake",
    "Bob",
    "Brad",
    "Eric",
    "James",
    "Jennifer",
    "Joan",
    "John",
    "Jolene",
    "Katherine",
    "Katie",
    "Leonard",
    "Leslie",
    "Mark",
    "Mary",
    "Matthew",
    "Nancy",
    "Paul",
    "Penelope",
    "Phillip",
    "Priscilla",
    "Sam",
    "Samantha",
    "Sarah",
    "Terry",
    "Xavier",
    "Yasmin"
  ],
  last: [
    "Anderson",
    "Bass",
    "Ballenger",
    "Barrero",
    "Carmichael",
    "Crowley",
    "Cruz",
    "Delaney",
    "Diamond",
    "Estep",
    "Farmer",
    "Fernandez",
    "Gardener",
    "Guerrero",
    "Halpin",
    "Hickey",
    "Ivery",
    "Johnson",
    "Jones",
    "Kennedy",
    "King",
    "LaMotte",
    "Madison",
    "Matthews",
    "Nadal",
    "O'Connor",
    "Pastides",
    "Richardson",
    "Roberts",
    "Sims",
    "Smith",
    "Taylor",
    "Tully",
    "Vazquez",
    "Warner"
  ]
};
